export const en = {
  // Navigation
  home: "Home",
  cart: "Cart",
  checkout: "Checkout",
  profile: "Profile",
  search: "Search",
  
  // Product listing
  addToCart: "Add to Cart",
  updateCart: "Update Cart",
  buyNow: "Buy Now",
  price: "Price",
  allProducts: "All Products",
  featuredItems: "Featured Items",
  specialOffers: "Special Offers",
  categories: "Categories",
  allCategories: "All categories",
  viewAll: "View All",
  youMightAlsoLike: "You Might Also Like",
  reviews: "reviews",
  exploreServices: "Explore Services",
  viewOffer: "View Offer",
  details: "Details",
  products: "Products & Services",
  item: "item",
  items: "items",
  
  // Search
  searchForProducts: "Search for products or services",
  recentSearches: "Recent Searches",
  noProductsFound: "No products found",
  
  // Cart
  yourCart: "Your Cart",
  emptyCart: "Your cart is empty",
  continueShopping: "Continue Shopping",
  removeItem: "Remove",
  quantity: "Quantity",
  total: "Total",
  subtotal: "Service costs",
  proceedToCheckout: "Proced to Checkout",
  browseServices: "Browse our services",
  
  // Checkout
  paymentDetails: "Payment Details",
  cardNumber: "Card Number",
  cardholderName: "Cardholder Name",
  expiryDate: "Expiry Date",
  cvv: "CVV",
  billingAddress: "Billing Address",
  placeOrder: "Place Order",
  processing: "Processing...",
  creditCard: "Credit Card",
  quickCheckout: "Quick Checkout",
  payOnDeliveryDesc: "Cash or card payment when your order arrives",
  continueWithPaypal: "Continue with PayPal",
  connectPaypal: "Connect PayPal",
  continueWithApplePay: "Continue with Apple Pay",
  connectApplePay: "Connect Apple Pay",
  orderSummary: "Order Summary",
  paymentMethod: "Payment Method",
  cardDetails: "Card Details",
  pay: "Pay",
  currency: "€",
  fullName: "Full Name",
  email: "Email",
  phone: "Phone Number",
  deliveryAddress: "Delivery Address",
  nameRequired: "Name is required",
  validEmailRequired: "Valid email is required",
  phoneRequired: "Phone number is required",
  addressRequired: "Delivery address is required",
  completeYourOrder: "Complete your order quickly with card payment",
  payWithCard: "Pay with card",
    
  // Confirmation
  orderConfirmed: "Order Confirmed!",
  thankYou: "Thank you for your order",
  orderNumber: "Order Number",
  summaryTitle: "Order Summary",
  backToShopping: "Back to Shopping",
  backToHome: "Back to Home",
  
  // Errors
  pageNotFound: "Page Not Found",
  returnHome: "Return to Home",
  
  // Language
  language: "Language",
  english: "English",
  spanish: "Spanish",
  italian: "Italian",
  
  // Hotel
  welcomeMessage: "Welcome to",
  
  // Misc
  loading: "Loading...",
  error: "An error occurred",
  retry: "Retry",
  close: "Close",


  noProductsAvailable: "Nessun prodotto disponibile",
  noProductsInCategory: "Nessun prodotto in questa categoria",
};